import { useState } from "react";
import ChevronDownIcon from "../../../../../../../../../../assets/svg/chevron-down-icon";
import type { FileDetailsAccordionProps } from "../../../types/fileManagement.types";

const FileDetailsAccordion = ({
  sections,
  contentMap,
}: FileDetailsAccordionProps) => {
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  const handleToggle = (sectionId: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      const isExpanding = !next.has(sectionId);
      if (isExpanding) {
        next.add(sectionId);
      } else {
        next.delete(sectionId);
      }
      if (isExpanding) {
        setTimeout(() => {
          document
            .getElementById(`section-${sectionId}`)
            ?.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 300);
      }
      return next;
    });
  };

  return (
    <div className="w-full">
      {sections?.map((section) => {
        const isExpanded = expanded.has(section.id);
        return (
          <div
            key={section.id}
            id={`section-${section.id}`}
            className="mx-6 border-b border-border-gray dark:border-border-gray-dk"
          >
            <button
              type="button"
              onClick={() => handleToggle(section.id)}
              className="group w-full flex items-center gap-1.5 py-4 cursor-pointer hover:bg-hover-effect dark:hover:bg-hover-effect-dk transition-colors"
            >
              <ChevronDownIcon
                className={`w-2.5 h-2.5 ml-1.5 transition-transform duration-300 text-verba-blue dark:text-verba-blue-dk shrink-0 ${
                  isExpanded ? "" : "-rotate-90"
                }`}
              />
              <span className="text-lg font-medium text-verba-indigo dark:text-verba-indigo-dk group-hover:text-verba-blue dark:group-hover:text-verba-blue-dk text-left">
                {section?.title}
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ease-in-out ${
                isExpanded ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
              }`}
            >
              <div className="overflow-hidden">{contentMap[section.id]}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FileDetailsAccordion;
